import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import BackToTop from "@/components/feature/BackToTop";
import JsonLd from "@/components/feature/JsonLd";
import { useSeo } from "@/hooks/useSeo";
import { categories } from "@/mocks/categories";
import { faqs } from "@/mocks/faqs";
import HeroSection from "./components/HeroSection";
import CategorySection from "./components/CategorySection";
import FeaturedSection from "./components/FeaturedSection";
import LatestSection from "./components/LatestSection";
import TestimonialSection from "./components/TestimonialSection";
import FaqPreviewSection from "./components/FaqPreviewSection";
import SubscribeSection from "./components/SubscribeSection";

export default function Home() {
  useSeo({
    title: "猎奇吃瓜｜未解之谜·灵异杂谈·都市传说与悬疑档案",
    description:
      "猎奇吃瓜深挖未解之谜、灵异杂谈与都市传说，持续更新超自然现象、悬疑档案与暗网传闻。想找刺激和烧脑内容，来这里看猎奇吃瓜悬疑档案，满足你的探索欲。",
    keywords: "猎奇吃瓜,未解之谜,灵异杂谈,都市传说,超自然现象,悬疑档案,暗网传闻",
    canonical: "/",
  });

  return (
    <div className="flex min-h-screen flex-col bg-background-950">
      <SiteHeader />
      <main className="flex-1">
        <HeroSection />
        <CategorySection />
        <FeaturedSection />
        <LatestSection />
        <TestimonialSection />
        <FaqPreviewSection />
        <SubscribeSection />
      </main>
      <SiteFooter />
      <BackToTop />

      <JsonLd
        id="home-itemlist"
        data={{
          "@context": "https://schema.org",
          "@type": "CollectionPage",
          name: "猎奇吃瓜 · 档案索引",
          description: "未解之谜、灵异杂谈、都市传说、超自然现象、悬疑档案与暗网传闻的题材索引。",
          url: "https://circleonly.cn/",
          inLanguage: "zh-CN",
          hasPart: categories.map((category) => ({
            "@type": "WebPage",
            name: category.name,
            description: category.desc,
            url: `https://circleonly.cn/archives?category=${category.slug}`,
          })),
        }}
      />
      <JsonLd
        id="home-faq"
        data={{
          "@context": "https://schema.org",
          "@type": "FAQPage",
          mainEntity: faqs.slice(0, 4).map((item) => ({
            "@type": "Question",
            name: item.question,
            acceptedAnswer: { "@type": "Answer", text: item.answer },
          })),
        }}
      />
    </div>
  );
}